// common/components/statusBar/StatusBar.tsx
import React from 'react'
import { useNavigate } from 'react-router-dom'
import classes from './StatusBar.module.sass'
import { ClusterInterface } from '../../types/interfaces'
import { useStatusBar } from './useStatusBar'

type Props = {
  isConnected: boolean
  clusters: ClusterInterface[]
}

export const StatusBar = ({ isConnected, clusters }: Props) => {
  const navigate = useNavigate()
  const { status: paymentStatus, message: paymentMessage } = useStatusBar(clusters)

  let finalStatus: 'ok' | 'warning' | 'error' = 'ok'
  let finalMessage = ''

  if (!isConnected) {
    finalStatus = 'error'
    finalMessage = 'Нет соединения, данные могут устареть'
  } else if (clusters.length > 0 && paymentStatus === 'warning') {
    finalStatus = 'warning'
    finalMessage = paymentMessage
  } else if (clusters.length > 0 && paymentStatus === 'error') {
    finalStatus = 'error'
    finalMessage = paymentMessage
  }

  if (finalStatus === 'ok') return null

  const handleClick = () => {
    navigate('/cluster')
  }

  if (process.env.REACT_APP_COUNTRY !== 'ru') return null

  return (
    <div className={finalStatus === 'error' ? classes.Error : classes.Warning}>
      <div className={classes.Message} onClick={handleClick}>
        {finalMessage}
      </div>
    </div>
  )
}
